const billing = {
    title: 'Billing & Subscriptions',
    revenue: 'Revenue',
    subscriptions: 'Subscriptions',
    invoices: 'Invoices',
  } as const;

export default billing;
